export default function DSA_Exercises() {
  return <div>DSA_Exercises Component</div>;
}
